export const endPoints = {
  NOTIF_CONFIG: 'v1/notification-config',
  NOTIF_CONFIG_SAVE: 'v1/notification-config/save'
};
